export const API_BASE = import.meta.env.VITE_API_BASE || '/examapi'
export const FILE_BASE = '/uploads'
export const LIMIT_AI_TOKEN = 500


export const levelMapping = { '1': 'ง่าย', '2': 'ปานกลาง', '3': 'ยาก', '4': 'ยากมาก' }
export const examTypeMapping = {
  multipleChoice: 'ปรนัย',
  trueFalse: 'ถูก/ผิด',
  fillBlank: 'เติมคำ',
  matching: 'จับคู่',
  shortAnswer: 'อัตนัย',
  ordering: 'เรียงลำดับ',
  mediaPrompt: 'โจทย์มีสื่อ',
  mediaChoice: 'ตัวเลือกมีสื่อ'
}

export const EXAM_STATUS = {
  0: { 
    label: 'รออนุมัติ', 
    style: 'bg-yellow-100 text-yellow-800 border-yellow-200' // สีเหลือง
  },
  1: { 
    label: 'อนุมัติ', 
    style: 'bg-green-100 text-green-800 border-green-200' // สีเขียว
  },
  2: { 
    label: 'ปฏิเสธ', 
    style: 'bg-red-100 text-red-800 border-red-200' // สีแดง
  },
  3: { 
    label: 'ฉบับร่าง', 
    style: 'bg-gray-100 text-gray-800 border-gray-200' // สีเทา
  }
};

export const typeSummaryMapping = { TF: 'ถูก 1 ข้อ', MT: 'ถูกมากกว่า 1 ข้อ', PO: 'ให้น้ำหนัก' }
export const typeOption_Order = { normal: 'เหมือนกัน', random: 'สลับแบบสุ่ม' }
export const typeExam_Order = { normal: 'เรียงเหมือนกัน', random: 'สลับข้อแบบสุ่ม' }

export const optionLabel = (i, style = 'thai') => {
  const TH = ['ก', 'ข', 'ค', 'ง', 'จ', 'ฉ', 'ช', 'ซ', 'ฌ', 'ญ']
  const AZ = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')
  const RM = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X']
  if (style === 'alphabet') return AZ[i] || i + 1
  if (style === 'number') return i + 1
  if (style === 'roman') return RM[i] || i + 1
  return TH[i] || i + 1
}

export const asArr = v =>
  Array.isArray(v) ? v
    : typeof v === 'string' && v.startsWith('{')
      ? v.replace(/[{}]/g, '').split(',').filter(Boolean)
      : [];

export const shuffleArray = (arr) => [...arr].sort(() => Math.random() - 0.5)

import { useState, useEffect } from 'react'
export const useDebounce = (v, d) => {
  const [val, setVal] = useState(v)
  useEffect(() => { const h = setTimeout(() => setVal(v), d); return () => clearTimeout(h) }, [v, d])
  return val
}

export const formatCountdown = (s) => [~~(s / 3600), ~~((s % 3600) / 60), s % 60].map(n => n.toString().padStart(2, '0')).join(':')


export const formatDate = (d, loc = 'th-TH') => {
  const t = new Date(d)
  return d && !isNaN(t) ? t.toLocaleDateString(loc, { year: 'numeric', month: 'short', day: 'numeric' }) : '-'
}

export const formatDateTime = (d, loc = 'th-TH') => {
  const t = new Date(d)
  return d && !isNaN(t) ? t.toLocaleDateString(loc, { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric' }) : '-'
}

import { format, isValid } from 'date-fns'

export const formatDateTimeShort = (isoString) => {
  const d = new Date(isoString)
  if (!isValid(d)) return '-'
  return format(d, 'dd/MM/yy HH:mm')
}



export const LANGUAGES = [
  { code: 'af', flag: 'za', label: 'Afrikaans', name: 'Afrikaans' },
  { code: 'am', flag: 'et', label: 'አማርኛ', name: 'Amharic' },
  { code: 'ar', flag: 'sa', label: 'العربية', name: 'Arabic' },
  { code: 'as', flag: 'in', label: 'অসমীয়া', name: 'Assamese' },
  { code: 'ay', flag: 'bo', label: 'Aymar Ar', name: 'Aymara' },
  { code: 'az', flag: 'az', label: 'Azərbaycan dili', name: 'Azerbaijani' },
  { code: 'be', flag: 'by', label: 'Беларуская', name: 'Belarusian' },
  { code: 'bg', flag: 'bg', label: 'Български', name: 'Bulgarian' },
  { code: 'bho', flag: 'in', label: 'भोजपुरी', name: 'Bhojpuri' },
  { code: 'bm', flag: 'ml', label: 'Bamanankan', name: 'Bambara' },
  { code: 'bn', flag: 'bd', label: 'বাংলা', name: 'Bangla' },
  { code: 'bs', flag: 'ba', label: 'Bosanski', name: 'Bosnian' },
  { code: 'ca', flag: 'es', label: 'Català', name: 'Catalan' },
  { code: 'ceb', flag: 'ph', label: 'Cebuano', name: 'Cebuano' },
  { code: 'ckb', flag: 'iq', label: 'کوردیی ناوەندی', name: 'Central Kurdish' },
  { code: 'co', flag: 'fr', label: 'Corsu', name: 'Corsican' },
  { code: 'cs', flag: 'cz', label: 'Čeština', name: 'Czech' },
  { code: 'cy', flag: 'gb-wls', label: 'Cymraeg', name: 'Welsh' },
  { code: 'da', flag: 'dk', label: 'Dansk', name: 'Danish' },
  { code: 'de', flag: 'de', label: 'Deutsch', name: 'German' },
  { code: 'dv', flag: 'mv', label: 'ދިވެހި', name: 'Divehi' },
  { code: 'doi', flag: 'in', label: 'Dogri', name: 'Dogri' },
  { code: 'ee', flag: 'gh', label: 'Eʋegbe', name: 'Ewe' },
  { code: 'el', flag: 'gr', label: 'Ελληνικά', name: 'Greek' },
  { code: 'en', flag: 'gb', label: 'English', name: 'English' },
  { code: 'eo', flag: 'eu', label: 'Esperanto', name: 'Esperanto' },
  { code: 'es', flag: 'es', label: 'Español', name: 'Spanish' },
  { code: 'et', flag: 'ee', label: 'Eesti', name: 'Estonian' },
  { code: 'eu', flag: 'es', label: 'Euskara', name: 'Basque' },
  { code: 'fa', flag: 'ir', label: 'فارسی', name: 'Persian' },
  { code: 'fi', flag: 'fi', label: 'Suomi', name: 'Finnish' },
  { code: 'fr', flag: 'fr', label: 'Français', name: 'French' },
  { code: 'fy', flag: 'nl', label: 'Frysk', name: 'Frisian' },
  { code: 'ga', flag: 'ie', label: 'Gaeilge', name: 'Irish' },
  { code: 'gd', flag: 'gb-sct', label: 'Gàidhlig', name: 'Scottish Gaelic' },
  { code: 'gl', flag: 'es', label: 'Galego', name: 'Galician' },
  { code: 'gn', flag: 'py', label: 'Avañeʼẽ', name: 'Guarani' },
  { code: 'gu', flag: 'in', label: 'ગુજરાતી', name: 'Gujarati' },
  { code: 'ha', flag: 'ng', label: 'Hausa', name: 'Hausa' },
  { code: 'haw', flag: 'us', label: 'ʻŌlelo Hawaiʻi', name: 'Hawaiian' },
  { code: 'he', flag: 'il', label: 'עברית', name: 'Hebrew' },
  { code: 'hi', flag: 'in', label: 'हिन्दी', name: 'Hindi' },
  { code: 'hmn', flag: 'cn', label: 'Hmong', name: 'Hmong' },
  { code: 'hr', flag: 'hr', label: 'Hrvatski', name: 'Croatian' },
  { code: 'ht', flag: 'ht', label: 'Kreyòl ayisyen', name: 'Haitian Creole' },
  { code: 'hu', flag: 'hu', label: 'Magyar', name: 'Hungarian' },
  { code: 'hy', flag: 'am', label: 'Հայերեն', name: 'Armenian' },
  { code: 'id', flag: 'id', label: 'Indonesia', name: 'Indonesian' },
  { code: 'ig', flag: 'ng', label: 'Igbo', name: 'Igbo' },
  { code: 'ilo', flag: 'ph', label: 'Ilocano', name: 'Ilocano' },
  { code: 'is', flag: 'is', label: 'Íslenska', name: 'Icelandic' },
  { code: 'it', flag: 'it', label: 'Italiano', name: 'Italian' },
  { code: 'ja', flag: 'jp', label: '日本語', name: 'Japanese' },
  { code: 'jv', flag: 'id', label: 'Basa Jawa', name: 'Javanese' },
  { code: 'ka', flag: 'ge', label: 'ქართული', name: 'Georgian' },
  { code: 'kk', flag: 'kz', label: 'Қазақ', name: 'Kazakh' },
  { code: 'km', flag: 'kh', label: 'ភាសាខ្មែរ', name: 'Khmer' },
  { code: 'kn', flag: 'in', label: 'ಕನ್ನಡ', name: 'Kannada' },
  { code: 'ko', flag: 'kr', label: '한국어', name: 'Korean' },
  { code: 'kri', flag: 'sl', label: 'Krio', name: 'Krio' },
  { code: 'ku', flag: 'iq', label: 'Kurdî', name: 'Kurdish (Kurmanji)' },
  { code: 'ky', flag: 'kg', label: 'Кыргызча', name: 'Kyrgyz' },
  { code: 'la', flag: 'va', label: 'Latina', name: 'Latin' },
  { code: 'lb', flag: 'lu', label: 'Lëtzebuergesch', name: 'Luxembourgish' },
  { code: 'lg', flag: 'ug', label: 'Luganda', name: 'Luganda' },
  { code: 'ln', flag: 'cd', label: 'Lingála', name: 'Lingala' },
  { code: 'lo', flag: 'la', label: 'ລາວ', name: 'Lao' },
  { code: 'lt', flag: 'lt', label: 'Lietuvių', name: 'Lithuanian' },
  { code: 'lus', flag: 'in', label: 'Mizo', name: 'Mizo' },
  { code: 'lv', flag: 'lv', label: 'Latviešu', name: 'Latvian' },
  { code: 'mg', flag: 'mg', label: 'Malagasy', name: 'Malagasy' },
  { code: 'mi', flag: 'nz', label: 'Māori', name: 'Maori' },
  { code: 'mk', flag: 'mk', label: 'Македонски', name: 'Macedonian' },
  { code: 'ml', flag: 'in', label: 'മലയാളം', name: 'Malayalam' },
  { code: 'mn', flag: 'mn', label: 'Монгол', name: 'Mongolian' },
  { code: 'mni', flag: 'in', label: 'Meitei / Manipuri', name: 'Meitei (Manipuri)' },
  { code: 'mr', flag: 'in', label: 'मराठी', name: 'Marathi' },
  { code: 'ms', flag: 'my', label: 'Bahasa Melayu', name: 'Malay' },
  { code: 'mt', flag: 'mt', label: 'Malti', name: 'Maltese' },
  { code: 'my', flag: 'mm', label: 'မြန်မာ', name: 'Burmese' },
  { code: 'ne', flag: 'np', label: 'नेपाली', name: 'Nepali' },
  { code: 'nl', flag: 'nl', label: 'Nederlands', name: 'Dutch' },
  { code: 'no', flag: 'no', label: 'Norsk', name: 'Norwegian' },
  { code: 'nso', flag: 'za', label: 'Sesotho sa Leboa', name: 'Northern Sotho' },
  { code: 'ny', flag: 'mw', label: 'ChiCheŵa', name: 'Chichewa' },
  { code: 'om', flag: 'et', label: 'Afaan Oromoo', name: 'Oromo' },
  { code: 'or', flag: 'in', label: 'ଓଡ଼ିଆ', name: 'Odia' },
  { code: 'pa', flag: 'in', label: 'ਪੰਜਾਬੀ', name: 'Punjabi' },
  { code: 'pl', flag: 'pl', label: 'Polski', name: 'Polish' },
  { code: 'ps', flag: 'af', label: 'پښتو', name: 'Pashto' },
  { code: 'pt', flag: 'pt', label: 'Português', name: 'Portuguese' },
  { code: 'qu', flag: 'pe', label: 'Runasimi', name: 'Quechua' },
  { code: 'ro', flag: 'ro', label: 'Română', name: 'Romanian' },
  { code: 'ru', flag: 'ru', label: 'Русский', name: 'Russian' },
  { code: 'rw', flag: 'rw', label: 'Kinyarwanda', name: 'Kinyarwanda' },
  { code: 'sa', flag: 'in', label: 'संस्कृतम्', name: 'Sanskrit' },
  { code: 'sd', flag: 'pk', label: 'سنڌي', name: 'Sindhi' },
  { code: 'si', flag: 'lk', label: 'සිංහල', name: 'Sinhala' },
  { code: 'sk', flag: 'sk', label: 'Slovenčina', name: 'Slovak' },
  { code: 'sl', flag: 'si', label: 'Slovenščina', name: 'Slovenian' },
  { code: 'sm', flag: 'ws', label: 'Gagana Sāmoa', name: 'Samoan' },
  { code: 'sn', flag: 'zw', label: 'Shona', name: 'Shona' },
  { code: 'so', flag: 'so', label: 'Soomaali', name: 'Somali' },
  { code: 'sq', flag: 'al', label: 'Shqip', name: 'Albanian' },
  { code: 'sr', flag: 'rs', label: 'Српски', name: 'Serbian' },
  { code: 'st', flag: 'za', label: 'Sesotho', name: 'Southern Sotho' },
  { code: 'su', flag: 'id', label: 'Basa Sunda', name: 'Sundanese' },
  { code: 'sv', flag: 'se', label: 'Svenska', name: 'Swedish' },
  { code: 'sw', flag: 'tz', label: 'Kiswahili', name: 'Swahili' },
  { code: 'ta', flag: 'in', label: 'தமிழ்', name: 'Tamil' },
  { code: 'te', flag: 'in', label: 'తెలుగు', name: 'Telugu' },
  { code: 'tg', flag: 'tj', label: 'Тоҷикӣ', name: 'Tajik' },
  { code: 'th', flag: 'th', label: 'ไทย', name: 'Thai' },
  { code: 'ti', flag: 'er', label: 'ትግርኛ', name: 'Tigrinya' },
  { code: 'tk', flag: 'tm', label: 'Türkmen', name: 'Turkmen' },
  { code: 'tl', flag: 'ph', label: 'Tagalog', name: 'Tagalog' },
  { code: 'tr', flag: 'tr', label: 'Türkçe', name: 'Turkish' },
  { code: 'ts', flag: 'za', label: 'Xitsonga', name: 'Tsonga' },
  { code: 'tt', flag: 'ru', label: 'Tatar', name: 'Tatar' },
  { code: 'ug', flag: 'cn', label: 'ئۇيغۇرچە', name: 'Uyghur' },
  { code: 'uk', flag: 'ua', label: 'Українська', name: 'Ukrainian' },
  { code: 'ur', flag: 'pk', label: 'اردو', name: 'Urdu' },
  { code: 'uz', flag: 'uz', label: 'Oʻzbekcha', name: 'Uzbek' },
  { code: 'vi', flag: 'vn', label: 'Tiếng Việt', name: 'Vietnamese' },
  { code: 'xh', flag: 'za', label: 'isiXhosa', name: 'Xhosa' },
  { code: 'yi', flag: 'il', label: 'ייִדיש', name: 'Yiddish' },
  { code: 'yo', flag: 'ng', label: 'Yorùbá', name: 'Yoruba' },
  { code: 'zh', flag: 'cn', label: '中文', name: 'Chinese (Simplified/Traditional)' },
  { code: 'zu', flag: 'za', label: 'IsiZulu', name: 'Zulu' }
]


export const LANGUAGES_AI = [
  { code: 'af', flag: 'za', label: 'Afrikaans', name: 'Afrikaans' },
  { code: 'ar', flag: 'sa', label: 'العربية', name: 'Arabic' },
  { code: 'bg', flag: 'bg', label: 'Български', name: 'Bulgarian' },
  { code: 'ca', flag: 'es', label: 'Català', name: 'Catalan' },
  { code: 'cs', flag: 'cz', label: 'Čeština', name: 'Czech' },
  { code: 'da', flag: 'dk', label: 'Dansk', name: 'Danish' },
  { code: 'de', flag: 'de', label: 'Deutsch', name: 'German' },
  { code: 'el', flag: 'gr', label: 'Ελληνικά', name: 'Greek' },
  { code: 'en', flag: 'gb', label: 'English', name: 'English' },
  { code: 'es', flag: 'es', label: 'Español', name: 'Spanish' },
  { code: 'et', flag: 'ee', label: 'Eesti', name: 'Estonian' },
  { code: 'fa', flag: 'ir', label: 'فارسی', name: 'Persian' },
  { code: 'fi', flag: 'fi', label: 'Suomi', name: 'Finnish' },
  { code: 'fr', flag: 'fr', label: 'Français', name: 'French' },
  { code: 'he', flag: 'il', label: 'עברית', name: 'Hebrew' },
  { code: 'hi', flag: 'in', label: 'हिन्दी', name: 'Hindi' },
  { code: 'hu', flag: 'hu', label: 'Magyar', name: 'Hungarian' },
  { code: 'id', flag: 'id', label: 'Bahasa Indonesia', name: 'Indonesian' },
  { code: 'it', flag: 'it', label: 'Italiano', name: 'Italian' },
  { code: 'ja', flag: 'jp', label: '日本語', name: 'Japanese' },
  { code: 'ko', flag: 'kr', label: '한국어', name: 'Korean' },
  { code: 'lt', flag: 'lt', label: 'Lietuvių', name: 'Lithuanian' },
  { code: 'nl', flag: 'nl', label: 'Nederlands', name: 'Dutch' },
  { code: 'no', flag: 'no', label: 'Norsk', name: 'Norwegian' },
  { code: 'pl', flag: 'pl', label: 'Polski', name: 'Polish' },
  { code: 'pt', flag: 'pt', label: 'Português', name: 'Portuguese' },
  { code: 'ro', flag: 'ro', label: 'Română', name: 'Romanian' },
  { code: 'ru', flag: 'ru', label: 'Русский', name: 'Russian' },
  { code: 'sk', flag: 'sk', label: 'Slovenčina', name: 'Slovak' },
  { code: 'sl', flag: 'si', label: 'Slovenščina', name: 'Slovenian' },
  { code: 'sv', flag: 'se', label: 'Svenska', name: 'Swedish' },
  { code: 'th', flag: 'th', label: 'ไทย', name: 'Thai' },
  { code: 'tr', flag: 'tr', label: 'Türkçe', name: 'Turkish' },
  { code: 'uk', flag: 'ua', label: 'Українська', name: 'Ukrainian' },
  { code: 'vi', flag: 'vn', label: 'Tiếng Việt', name: 'Vietnamese' },
  { code: 'zh', flag: 'cn', label: '中文', name: 'Chinese' }
];




export const browserLocale = navigator.language || navigator.userLanguage || 'th'
export const localeToLabel = (loc) => {
  const p = loc.split('-')[0].toLowerCase()
  const hit = LANGUAGES.find(l => l.code?.toLowerCase() === p) || LANGUAGES.find(l => l.label.toLowerCase().startsWith(p))
  return hit ? hit.label : 'Thai'
}


export const countryCode =
  [
    {
      "name": "Afghanistan",
      "dial_code": "+93",
      "code": "AF"
    },
    {
      "name": "Aland Islands",
      "dial_code": "+358",
      "code": "AX"
    },
    {
      "name": "Albania",
      "dial_code": "+355",
      "code": "AL"
    },
    {
      "name": "Algeria",
      "dial_code": "+213",
      "code": "DZ"
    },
    {
      "name": "AmericanSamoa",
      "dial_code": "+1684",
      "code": "AS"
    },
    {
      "name": "Andorra",
      "dial_code": "+376",
      "code": "AD"
    },
    {
      "name": "Angola",
      "dial_code": "+244",
      "code": "AO"
    },
    {
      "name": "Anguilla",
      "dial_code": "+1264",
      "code": "AI"
    },
    {
      "name": "Antarctica",
      "dial_code": "+672",
      "code": "AQ"
    },
    {
      "name": "Antigua and Barbuda",
      "dial_code": "+1268",
      "code": "AG"
    },
    {
      "name": "Argentina",
      "dial_code": "+54",
      "code": "AR"
    },
    {
      "name": "Armenia",
      "dial_code": "+374",
      "code": "AM"
    },
    {
      "name": "Aruba",
      "dial_code": "+297",
      "code": "AW"
    },
    {
      "name": "Australia",
      "dial_code": "+61",
      "code": "AU"
    },
    {
      "name": "Austria",
      "dial_code": "+43",
      "code": "AT"
    },
    {
      "name": "Azerbaijan",
      "dial_code": "+994",
      "code": "AZ"
    },
    {
      "name": "Bahamas",
      "dial_code": "+1242",
      "code": "BS"
    },
    {
      "name": "Bahrain",
      "dial_code": "+973",
      "code": "BH"
    },
    {
      "name": "Bangladesh",
      "dial_code": "+880",
      "code": "BD"
    },
    {
      "name": "Barbados",
      "dial_code": "+1246",
      "code": "BB"
    },
    {
      "name": "Belarus",
      "dial_code": "+375",
      "code": "BY"
    },
    {
      "name": "Belgium",
      "dial_code": "+32",
      "code": "BE"
    },
    {
      "name": "Belize",
      "dial_code": "+501",
      "code": "BZ"
    },
    {
      "name": "Benin",
      "dial_code": "+229",
      "code": "BJ"
    },
    {
      "name": "Bermuda",
      "dial_code": "+1441",
      "code": "BM"
    },
    {
      "name": "Bhutan",
      "dial_code": "+975",
      "code": "BT"
    },
    {
      "name": "Bolivia, Plurinational State of",
      "dial_code": "+591",
      "code": "BO"
    },
    {
      "name": "Bosnia and Herzegovina",
      "dial_code": "+387",
      "code": "BA"
    },
    {
      "name": "Botswana",
      "dial_code": "+267",
      "code": "BW"
    },
    {
      "name": "Brazil",
      "dial_code": "+55",
      "code": "BR"
    },
    {
      "name": "British Indian Ocean Territory",
      "dial_code": "+246",
      "code": "IO"
    },
    {
      "name": "Brunei Darussalam",
      "dial_code": "+673",
      "code": "BN"
    },
    {
      "name": "Bulgaria",
      "dial_code": "+359",
      "code": "BG"
    },
    {
      "name": "Burkina Faso",
      "dial_code": "+226",
      "code": "BF"
    },
    {
      "name": "Burundi",
      "dial_code": "+257",
      "code": "BI"
    },
    {
      "name": "Cambodia",
      "dial_code": "+855",
      "code": "KH"
    },
    {
      "name": "Cameroon",
      "dial_code": "+237",
      "code": "CM"
    },
    {
      "name": "Canada",
      "dial_code": "+1",
      "code": "CA"
    },
    {
      "name": "Cape Verde",
      "dial_code": "+238",
      "code": "CV"
    },
    {
      "name": "Cayman Islands",
      "dial_code": "+ 345",
      "code": "KY"
    },
    {
      "name": "Central African Republic",
      "dial_code": "+236",
      "code": "CF"
    },
    {
      "name": "Chad",
      "dial_code": "+235",
      "code": "TD"
    },
    {
      "name": "Chile",
      "dial_code": "+56",
      "code": "CL"
    },
    {
      "name": "China",
      "dial_code": "+86",
      "code": "CN"
    },
    {
      "name": "Christmas Island",
      "dial_code": "+61",
      "code": "CX"
    },
    {
      "name": "Cocos (Keeling) Islands",
      "dial_code": "+61",
      "code": "CC"
    },
    {
      "name": "Colombia",
      "dial_code": "+57",
      "code": "CO"
    },
    {
      "name": "Comoros",
      "dial_code": "+269",
      "code": "KM"
    },
    {
      "name": "Congo",
      "dial_code": "+242",
      "code": "CG"
    },
    {
      "name": "Congo, The Democratic Republic of the Congo",
      "dial_code": "+243",
      "code": "CD"
    },
    {
      "name": "Cook Islands",
      "dial_code": "+682",
      "code": "CK"
    },
    {
      "name": "Costa Rica",
      "dial_code": "+506",
      "code": "CR"
    },
    {
      "name": "Cote d'Ivoire",
      "dial_code": "+225",
      "code": "CI"
    },
    {
      "name": "Croatia",
      "dial_code": "+385",
      "code": "HR"
    },
    {
      "name": "Cuba",
      "dial_code": "+53",
      "code": "CU"
    },
    {
      "name": "Cyprus",
      "dial_code": "+357",
      "code": "CY"
    },
    {
      "name": "Czech Republic",
      "dial_code": "+420",
      "code": "CZ"
    },
    {
      "name": "Denmark",
      "dial_code": "+45",
      "code": "DK"
    },
    {
      "name": "Djibouti",
      "dial_code": "+253",
      "code": "DJ"
    },
    {
      "name": "Dominica",
      "dial_code": "+1767",
      "code": "DM"
    },
    {
      "name": "Dominican Republic",
      "dial_code": "+1849",
      "code": "DO"
    },
    {
      "name": "Ecuador",
      "dial_code": "+593",
      "code": "EC"
    },
    {
      "name": "Egypt",
      "dial_code": "+20",
      "code": "EG"
    },
    {
      "name": "El Salvador",
      "dial_code": "+503",
      "code": "SV"
    },
    {
      "name": "Equatorial Guinea",
      "dial_code": "+240",
      "code": "GQ"
    },
    {
      "name": "Eritrea",
      "dial_code": "+291",
      "code": "ER"
    },
    {
      "name": "Estonia",
      "dial_code": "+372",
      "code": "EE"
    },
    {
      "name": "Ethiopia",
      "dial_code": "+251",
      "code": "ET"
    },
    {
      "name": "Falkland Islands (Malvinas)",
      "dial_code": "+500",
      "code": "FK"
    },
    {
      "name": "Faroe Islands",
      "dial_code": "+298",
      "code": "FO"
    },
    {
      "name": "Fiji",
      "dial_code": "+679",
      "code": "FJ"
    },
    {
      "name": "Finland",
      "dial_code": "+358",
      "code": "FI"
    },
    {
      "name": "France",
      "dial_code": "+33",
      "code": "FR"
    },
    {
      "name": "French Guiana",
      "dial_code": "+594",
      "code": "GF"
    },
    {
      "name": "French Polynesia",
      "dial_code": "+689",
      "code": "PF"
    },
    {
      "name": "Gabon",
      "dial_code": "+241",
      "code": "GA"
    },
    {
      "name": "Gambia",
      "dial_code": "+220",
      "code": "GM"
    },
    {
      "name": "Georgia",
      "dial_code": "+995",
      "code": "GE"
    },
    {
      "name": "Germany",
      "dial_code": "+49",
      "code": "DE"
    },
    {
      "name": "Ghana",
      "dial_code": "+233",
      "code": "GH"
    },
    {
      "name": "Gibraltar",
      "dial_code": "+350",
      "code": "GI"
    },
    {
      "name": "Greece",
      "dial_code": "+30",
      "code": "GR"
    },
    {
      "name": "Greenland",
      "dial_code": "+299",
      "code": "GL"
    },
    {
      "name": "Grenada",
      "dial_code": "+1473",
      "code": "GD"
    },
    {
      "name": "Guadeloupe",
      "dial_code": "+590",
      "code": "GP"
    },
    {
      "name": "Guam",
      "dial_code": "+1671",
      "code": "GU"
    },
    {
      "name": "Guatemala",
      "dial_code": "+502",
      "code": "GT"
    },
    {
      "name": "Guernsey",
      "dial_code": "+44",
      "code": "GG"
    },
    {
      "name": "Guinea",
      "dial_code": "+224",
      "code": "GN"
    },
    {
      "name": "Guinea-Bissau",
      "dial_code": "+245",
      "code": "GW"
    },
    {
      "name": "Guyana",
      "dial_code": "+595",
      "code": "GY"
    },
    {
      "name": "Haiti",
      "dial_code": "+509",
      "code": "HT"
    },
    {
      "name": "Holy See (Vatican City State)",
      "dial_code": "+379",
      "code": "VA"
    },
    {
      "name": "Honduras",
      "dial_code": "+504",
      "code": "HN"
    },
    {
      "name": "Hong Kong",
      "dial_code": "+852",
      "code": "HK"
    },
    {
      "name": "Hungary",
      "dial_code": "+36",
      "code": "HU"
    },
    {
      "name": "Iceland",
      "dial_code": "+354",
      "code": "IS"
    },
    {
      "name": "India",
      "dial_code": "+91",
      "code": "IN"
    },
    {
      "name": "Indonesia",
      "dial_code": "+62",
      "code": "ID"
    },
    {
      "name": "Iran, Islamic Republic of Persian Gulf",
      "dial_code": "+98",
      "code": "IR"
    },
    {
      "name": "Iraq",
      "dial_code": "+964",
      "code": "IQ"
    },
    {
      "name": "Ireland",
      "dial_code": "+353",
      "code": "IE"
    },
    {
      "name": "Isle of Man",
      "dial_code": "+44",
      "code": "IM"
    },
    {
      "name": "Israel",
      "dial_code": "+972",
      "code": "IL"
    },
    {
      "name": "Italy",
      "dial_code": "+39",
      "code": "IT"
    },
    {
      "name": "Jamaica",
      "dial_code": "+1876",
      "code": "JM"
    },
    {
      "name": "Japan",
      "dial_code": "+81",
      "code": "JP"
    },
    {
      "name": "Jersey",
      "dial_code": "+44",
      "code": "JE"
    },
    {
      "name": "Jordan",
      "dial_code": "+962",
      "code": "JO"
    },
    {
      "name": "Kazakhstan",
      "dial_code": "+77",
      "code": "KZ"
    },
    {
      "name": "Kenya",
      "dial_code": "+254",
      "code": "KE"
    },
    {
      "name": "Kiribati",
      "dial_code": "+686",
      "code": "KI"
    },
    {
      "name": "Korea, Democratic People's Republic of Korea",
      "dial_code": "+850",
      "code": "KP"
    },
    {
      "name": "Korea, Republic of South Korea",
      "dial_code": "+82",
      "code": "KR"
    },
    {
      "name": "Kuwait",
      "dial_code": "+965",
      "code": "KW"
    },
    {
      "name": "Kyrgyzstan",
      "dial_code": "+996",
      "code": "KG"
    },
    {
      "name": "Laos",
      "dial_code": "+856",
      "code": "LA"
    },
    {
      "name": "Latvia",
      "dial_code": "+371",
      "code": "LV"
    },
    {
      "name": "Lebanon",
      "dial_code": "+961",
      "code": "LB"
    },
    {
      "name": "Lesotho",
      "dial_code": "+266",
      "code": "LS"
    },
    {
      "name": "Liberia",
      "dial_code": "+231",
      "code": "LR"
    },
    {
      "name": "Libyan Arab Jamahiriya",
      "dial_code": "+218",
      "code": "LY"
    },
    {
      "name": "Liechtenstein",
      "dial_code": "+423",
      "code": "LI"
    },
    {
      "name": "Lithuania",
      "dial_code": "+370",
      "code": "LT"
    },
    {
      "name": "Luxembourg",
      "dial_code": "+352",
      "code": "LU"
    },
    {
      "name": "Macao",
      "dial_code": "+853",
      "code": "MO"
    },
    {
      "name": "Macedonia",
      "dial_code": "+389",
      "code": "MK"
    },
    {
      "name": "Madagascar",
      "dial_code": "+261",
      "code": "MG"
    },
    {
      "name": "Malawi",
      "dial_code": "+265",
      "code": "MW"
    },
    {
      "name": "Malaysia",
      "dial_code": "+60",
      "code": "MY"
    },
    {
      "name": "Maldives",
      "dial_code": "+960",
      "code": "MV"
    },
    {
      "name": "Mali",
      "dial_code": "+223",
      "code": "ML"
    },
    {
      "name": "Malta",
      "dial_code": "+356",
      "code": "MT"
    },
    {
      "name": "Marshall Islands",
      "dial_code": "+692",
      "code": "MH"
    },
    {
      "name": "Martinique",
      "dial_code": "+596",
      "code": "MQ"
    },
    {
      "name": "Mauritania",
      "dial_code": "+222",
      "code": "MR"
    },
    {
      "name": "Mauritius",
      "dial_code": "+230",
      "code": "MU"
    },
    {
      "name": "Mayotte",
      "dial_code": "+262",
      "code": "YT"
    },
    {
      "name": "Mexico",
      "dial_code": "+52",
      "code": "MX"
    },
    {
      "name": "Micronesia, Federated States of Micronesia",
      "dial_code": "+691",
      "code": "FM"
    },
    {
      "name": "Moldova",
      "dial_code": "+373",
      "code": "MD"
    },
    {
      "name": "Monaco",
      "dial_code": "+377",
      "code": "MC"
    },
    {
      "name": "Mongolia",
      "dial_code": "+976",
      "code": "MN"
    },
    {
      "name": "Montenegro",
      "dial_code": "+382",
      "code": "ME"
    },
    {
      "name": "Montserrat",
      "dial_code": "+1664",
      "code": "MS"
    },
    {
      "name": "Morocco",
      "dial_code": "+212",
      "code": "MA"
    },
    {
      "name": "Mozambique",
      "dial_code": "+258",
      "code": "MZ"
    },
    {
      "name": "Myanmar",
      "dial_code": "+95",
      "code": "MM"
    },
    {
      "name": "Namibia",
      "dial_code": "+264",
      "code": "NA"
    },
    {
      "name": "Nauru",
      "dial_code": "+674",
      "code": "NR"
    },
    {
      "name": "Nepal",
      "dial_code": "+977",
      "code": "NP"
    },
    {
      "name": "Netherlands",
      "dial_code": "+31",
      "code": "NL"
    },
    {
      "name": "Netherlands Antilles",
      "dial_code": "+599",
      "code": "AN"
    },
    {
      "name": "New Caledonia",
      "dial_code": "+687",
      "code": "NC"
    },
    {
      "name": "New Zealand",
      "dial_code": "+64",
      "code": "NZ"
    },
    {
      "name": "Nicaragua",
      "dial_code": "+505",
      "code": "NI"
    },
    {
      "name": "Niger",
      "dial_code": "+227",
      "code": "NE"
    },
    {
      "name": "Nigeria",
      "dial_code": "+234",
      "code": "NG"
    },
    {
      "name": "Niue",
      "dial_code": "+683",
      "code": "NU"
    },
    {
      "name": "Norfolk Island",
      "dial_code": "+672",
      "code": "NF"
    },
    {
      "name": "Northern Mariana Islands",
      "dial_code": "+1670",
      "code": "MP"
    },
    {
      "name": "Norway",
      "dial_code": "+47",
      "code": "NO"
    },
    {
      "name": "Oman",
      "dial_code": "+968",
      "code": "OM"
    },
    {
      "name": "Pakistan",
      "dial_code": "+92",
      "code": "PK"
    },
    {
      "name": "Palau",
      "dial_code": "+680",
      "code": "PW"
    },
    {
      "name": "Palestinian Territory, Occupied",
      "dial_code": "+970",
      "code": "PS"
    },
    {
      "name": "Panama",
      "dial_code": "+507",
      "code": "PA"
    },
    {
      "name": "Papua New Guinea",
      "dial_code": "+675",
      "code": "PG"
    },
    {
      "name": "Paraguay",
      "dial_code": "+595",
      "code": "PY"
    },
    {
      "name": "Peru",
      "dial_code": "+51",
      "code": "PE"
    },
    {
      "name": "Philippines",
      "dial_code": "+63",
      "code": "PH"
    },
    {
      "name": "Pitcairn",
      "dial_code": "+872",
      "code": "PN"
    },
    {
      "name": "Poland",
      "dial_code": "+48",
      "code": "PL"
    },
    {
      "name": "Portugal",
      "dial_code": "+351",
      "code": "PT"
    },
    {
      "name": "Puerto Rico",
      "dial_code": "+1939",
      "code": "PR"
    },
    {
      "name": "Qatar",
      "dial_code": "+974",
      "code": "QA"
    },
    {
      "name": "Romania",
      "dial_code": "+40",
      "code": "RO"
    },
    {
      "name": "Russia",
      "dial_code": "+7",
      "code": "RU"
    },
    {
      "name": "Rwanda",
      "dial_code": "+250",
      "code": "RW"
    },
    {
      "name": "Reunion",
      "dial_code": "+262",
      "code": "RE"
    },
    {
      "name": "Saint Barthelemy",
      "dial_code": "+590",
      "code": "BL"
    },
    {
      "name": "Saint Helena, Ascension and Tristan Da Cunha",
      "dial_code": "+290",
      "code": "SH"
    },
    {
      "name": "Saint Kitts and Nevis",
      "dial_code": "+1869",
      "code": "KN"
    },
    {
      "name": "Saint Lucia",
      "dial_code": "+1758",
      "code": "LC"
    },
    {
      "name": "Saint Martin",
      "dial_code": "+590",
      "code": "MF"
    },
    {
      "name": "Saint Pierre and Miquelon",
      "dial_code": "+508",
      "code": "PM"
    },
    {
      "name": "Saint Vincent and the Grenadines",
      "dial_code": "+1784",
      "code": "VC"
    },
    {
      "name": "Samoa",
      "dial_code": "+685",
      "code": "WS"
    },
    {
      "name": "San Marino",
      "dial_code": "+378",
      "code": "SM"
    },
    {
      "name": "Sao Tome and Principe",
      "dial_code": "+239",
      "code": "ST"
    },
    {
      "name": "Saudi Arabia",
      "dial_code": "+966",
      "code": "SA"
    },
    {
      "name": "Senegal",
      "dial_code": "+221",
      "code": "SN"
    },
    {
      "name": "Serbia",
      "dial_code": "+381",
      "code": "RS"
    },
    {
      "name": "Seychelles",
      "dial_code": "+248",
      "code": "SC"
    },
    {
      "name": "Sierra Leone",
      "dial_code": "+232",
      "code": "SL"
    },
    {
      "name": "Singapore",
      "dial_code": "+65",
      "code": "SG"
    },
    {
      "name": "Slovakia",
      "dial_code": "+421",
      "code": "SK"
    },
    {
      "name": "Slovenia",
      "dial_code": "+386",
      "code": "SI"
    },
    {
      "name": "Solomon Islands",
      "dial_code": "+677",
      "code": "SB"
    },
    {
      "name": "Somalia",
      "dial_code": "+252",
      "code": "SO"
    },
    {
      "name": "South Africa",
      "dial_code": "+27",
      "code": "ZA"
    },
    {
      "name": "South Sudan",
      "dial_code": "+211",
      "code": "SS"
    },
    {
      "name": "South Georgia and the South Sandwich Islands",
      "dial_code": "+500",
      "code": "GS"
    },
    {
      "name": "Spain",
      "dial_code": "+34",
      "code": "ES"
    },
    {
      "name": "Sri Lanka",
      "dial_code": "+94",
      "code": "LK"
    },
    {
      "name": "Sudan",
      "dial_code": "+249",
      "code": "SD"
    },
    {
      "name": "Suriname",
      "dial_code": "+597",
      "code": "SR"
    },
    {
      "name": "Svalbard and Jan Mayen",
      "dial_code": "+47",
      "code": "SJ"
    },
    {
      "name": "Swaziland",
      "dial_code": "+268",
      "code": "SZ"
    },
    {
      "name": "Sweden",
      "dial_code": "+46",
      "code": "SE"
    },
    {
      "name": "Switzerland",
      "dial_code": "+41",
      "code": "CH"
    },
    {
      "name": "Syrian Arab Republic",
      "dial_code": "+963",
      "code": "SY"
    },
    {
      "name": "Taiwan",
      "dial_code": "+886",
      "code": "TW"
    },
    {
      "name": "Tajikistan",
      "dial_code": "+992",
      "code": "TJ"
    },
    {
      "name": "Tanzania, United Republic of Tanzania",
      "dial_code": "+255",
      "code": "TZ"
    },
    {
      "name": "Thailand",
      "dial_code": "+66",
      "code": "TH"
    },
    {
      "name": "Timor-Leste",
      "dial_code": "+670",
      "code": "TL"
    },
    {
      "name": "Togo",
      "dial_code": "+228",
      "code": "TG"
    },
    {
      "name": "Tokelau",
      "dial_code": "+690",
      "code": "TK"
    },
    {
      "name": "Tonga",
      "dial_code": "+676",
      "code": "TO"
    },
    {
      "name": "Trinidad and Tobago",
      "dial_code": "+1868",
      "code": "TT"
    },
    {
      "name": "Tunisia",
      "dial_code": "+216",
      "code": "TN"
    },
    {
      "name": "Turkey",
      "dial_code": "+90",
      "code": "TR"
    },
    {
      "name": "Turkmenistan",
      "dial_code": "+993",
      "code": "TM"
    },
    {
      "name": "Turks and Caicos Islands",
      "dial_code": "+1649",
      "code": "TC"
    },
    {
      "name": "Tuvalu",
      "dial_code": "+688",
      "code": "TV"
    },
    {
      "name": "Uganda",
      "dial_code": "+256",
      "code": "UG"
    },
    {
      "name": "Ukraine",
      "dial_code": "+380",
      "code": "UA"
    },
    {
      "name": "United Arab Emirates",
      "dial_code": "+971",
      "code": "AE"
    },
    {
      "name": "United Kingdom",
      "dial_code": "+44",
      "code": "GB"
    },
    {
      "name": "United States",
      "dial_code": "+1",
      "code": "US"
    },
    {
      "name": "Uruguay",
      "dial_code": "+598",
      "code": "UY"
    },
    {
      "name": "Uzbekistan",
      "dial_code": "+998",
      "code": "UZ"
    },
    {
      "name": "Vanuatu",
      "dial_code": "+678",
      "code": "VU"
    },
    {
      "name": "Venezuela, Bolivarian Republic of Venezuela",
      "dial_code": "+58",
      "code": "VE"
    },
    {
      "name": "Vietnam",
      "dial_code": "+84",
      "code": "VN"
    },
    {
      "name": "Virgin Islands, British",
      "dial_code": "+1284",
      "code": "VG"
    },
    {
      "name": "Virgin Islands, U.S.",
      "dial_code": "+1340",
      "code": "VI"
    },
    {
      "name": "Wallis and Futuna",
      "dial_code": "+681",
      "code": "WF"
    },
    {
      "name": "Yemen",
      "dial_code": "+967",
      "code": "YE"
    },
    {
      "name": "Zambia",
      "dial_code": "+260",
      "code": "ZM"
    },
    {
      "name": "Zimbabwe",
      "dial_code": "+263",
      "code": "ZW"
    }
  ]
